import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { Button, Spin } from "antd";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import styles from "./Observador.module.css";
import {
  MISSATGE_SPIN_OBSERVADORS,
  TITOL_OBSERVADORS
} from "../../constantsFormularis";
import { LOCAL_STORAGE_USER } from "../../constantsObservacions";
import {
  obtenirObservadorsLlistat,
  getDadesObservadorSeleccionat,
  setTitolApartat,
  obtenirMunicipis
} from "../../actions";
import {
  getMunicipis,
  getUsuari,
  getPeticioObservadorsEnCurs,
  getObservadorsUsuari
} from "../../reducers";
import { rutaLogin, rutaIntroduccioObservador } from "../../routes";
import ObservadorTaula from "./ObservadorTaula";
import ErrorBoundaryWrapper from "../commons/ErrorBoundaryWrapper";
import { calFerLogin, senseRols, tokenDecoded } from "../../utils/usuariRols";
import { esLlistaBuida } from "../../utils/formularis";
import { NotificacioError } from "../Notification";

class Observador extends Component {
  constructor(props) {
    super(props);
    this.renderitzarTaula = this.renderitzarTaula.bind(this);
  }

  componentDidMount() {
    this.props.setTitolApartat(TITOL_OBSERVADORS);
    this.obtenirObservadors();
    if (!this.props.municipis || this.props.municipis.length === 0) {
      this.props.obtenirMunicipis();
    }
  }

  obtenirObservadors = () => {
    this.props
      .obtenirObservadorsLlistat()
      .then(dades => {
        if (dades.error || (dades.payload && dades.payload.message)) {
          return NotificacioError(
            "Avís llistat d'observadors",
            dades.error && dades.error.message
              ? dades.error.message
              : dades.payload.message
          );
        }
        if (esLlistaBuida(dades.payload, "observadors")) {
          return NotificacioError("Avís", "No s'han trobat observadors.");
        }
      })
      .catch(error => {
        if (error.message && error.titol) {
          return NotificacioError(error.titol, error.message);
        }
      });
  };

  renderitzarTaula() {
    const { observadors, getDadesObservadorSeleccionat, history } = this.props;

    return (
      <ObservadorTaula
        observadors={observadors}
        history={history}
        getDadesObservadorSeleccionat={getDadesObservadorSeleccionat}
      />
    );
  }

  recuperarUsuari = usuari => {
    if (!calFerLogin(usuari)) {
      return this.tokenTrobat(usuari);
    } else {
      const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER));
      if (token) {
        return this.tokenTrobat(tokenDecoded(token.token));
      } else {
        return <Redirect to={rutaLogin} />;
      }
    }
  };

  tokenTrobat = usuari => {
    const { isPeticioEnCurs, observadors } = this.props;

    if (senseRols(usuari)) {
      return <Redirect to={rutaLogin} />;
    }

    const hihaDades =
      observadors && Array.isArray(observadors) && observadors.length > 0;

    return (
      <Spin
        spinning={isPeticioEnCurs}
        tip={MISSATGE_SPIN_OBSERVADORS}
        delay={300}
      >
        <div className={styles.observadorBotoInserir}>
          <Link to={rutaIntroduccioObservador}>
            <Button type="primary" icon="plus-circle-o">
              Observador
            </Button>
          </Link>
        </div>
        {hihaDades ? (
          <div className={styles.observador}>{this.renderitzarTaula()}</div>
        ) : null}
      </Spin>
    );
  };

  render() {
    return this.recuperarUsuari(this.props.usuari);
  }
}

Observador.propTypes = {
  observadors: PropTypes.array,
  obtenirObservadorsLlistat: PropTypes.func,
  isPeticioEnCurs: PropTypes.bool,
  getDadesObservadorSeleccionat: PropTypes.func,
  obtenirMunicipis: PropTypes.func,
  history: PropTypes.object,
  setTitolApartat: PropTypes.func.isRequired,
  municipis: PropTypes.array,
  usuari: PropTypes.object
};

const mapStateToProps = state => {
  return {
    isPeticioEnCurs: getPeticioObservadorsEnCurs(state),
    observadors: getObservadorsUsuari(state),
    municipis: getMunicipis(state),
    usuari: getUsuari(state)
  };
};

const mapDispatchToProps = {
  obtenirObservadorsLlistat,
  getDadesObservadorSeleccionat,
  setTitolApartat,
  obtenirMunicipis
};

export default ErrorBoundaryWrapper(
  connect(mapStateToProps, mapDispatchToProps)(Observador)
);
